<script>
import { date } from 'quasar'
import { saveAs } from 'file-saver/FileSaver'
import { toArrayBuffer, formatDate } from 'src/utils'
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import { required, email, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
import { emailErrors, passwordErrors, confirmPasswordErrors } from 'src/plugins/validations'
import Grid from '../Shared/Grid'
import ClassDetailsModal from '../Class/ClassDetailsModal'
// import NYStudentCompletion from './NYStudentCompletion.vue';

export default {
  name: 'StudentCompletion',
  components: {
    Grid,
    ClassDetailsModal
  },
  props: { // Flag used to determine if the modal should be open or closed
    'toggle': Function // Changes the flag to typically a false state
  },
  mounted () {
    this.$store.dispatch('courses/fetch', {})
  },
  validations: {
  },
  data () {
    return {
      open: true,
      selectedState: [],
      currentStep: 'start',
      visibleColumns: ['Exception', 'DRIVERS_LICENSE', 'AFFILIATE_CODE', 'FIRST_NAME', 'COMPLETED_DATE'],
      columnOptions: [
        { field: 'exceptionInfo', name: 'Exception', label: 'Exception'},
        { field: 'DRIVERS_LICENSE', name: 'DRIVERS_LICENSE', label: 'Drivers License', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'AFFILIATE_CODE', name: 'AFFILIATE_CODE', label: 'Agency Code', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'FIRST_NAME', name: 'FIRST_NAME', label: 'First Name', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'LAST_NAME', name: 'LAST_NAME', label: 'Last Name', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'MIDDLE_NAME', name: 'MIDDLE_NAME', label: 'Middle Name', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'DOB', name: 'DOB', label: 'Date of Birth', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'COMPLETED_DATE', name: 'COMPLETED_DATE', label: 'Completed Date', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'SPONSOR_CODE', name: 'SPONSOR_CODE', label: 'Sponsor Code', sortable: true, filter: null, type: 'string', exception: false },
        { field: 'STUDENT_ID', name: 'STUDENT_ID', label: 'Student ID' },
        { field: 'CLASS_ID', name: 'CLASS_ID', label: 'Class ID'}
      ],
      // paginationOptions: {
      //   rowsPerPage: 10,
      //   page:1
      // },
      maximized: false
    }
  },
  computed: {
    ...mapState({
      studentCompletionModal: s => s.shared.studentCompletionModal,
    }),
    ...mapState('reports', {
      studentCompletionList: s => s.studentCompletionList,
      studentExceptionList: s => s.studentExceptionList,
      studentCompletionForm: s => s.studentCompletionForm,
      selectedStudents:      s => s.selectedStudents,
      loading: s => s.loading
    }),
    ...mapGetters([
      'stateNameOptions',
    ]),
    ...mapGetters('courses', [
      'courseOptions'
    ]),
    // ...mapGetters('reports',[
    //   'studentCompletionReport',
    //   'studentCompletionExceptionMap',
    //   'studentCompletionExceptionReport'
    // ]),
    startDate () {
      return formatDate(this.studentCompletionForm.START_DATE)
    },
    maxEndDate () {
      return date.addToDate(this.studentCompletionForm.START_DATE, { days: 31 })
    },
    endDate () {
      return formatDate(this.studentCompletionForm.END_DATE)
    },
    runLabel () {
      return (this.currentStep === 'review') ? 'Re-run' : 'Run'
    },
    runIcon () {
      return (this.currentStep === 'review') ? 'fa fa-rotate-right' : 'fa fa-gear' 
    },
    disableRun () {
      const disable = (!this.studentCompletionForm.START_DATE || !this.studentCompletionForm.END_DATE)
      return disable
    },
    disableNext () {
      switch (this.currentStep) {
        case 'state' :
          return !this.studentCompletionForm.LK_STATE_ID
        case 'course' :
          return !this.studentCompletionForm.COURSE_ID
        case 'date' :
          return !this.studentCompletionForm.START_DATE && this.studentCompletionForm.END_DATE
        default :
          return false
      // if (this.currentStep === 'state') {
      //   return !this.studentCompletionForm.LK_STATE_ID
      // } else if (this.currentStep === 'course') {
      //   return !this.studentCompletionForm.COURSE_ID
      // } else if (this.currentStep === 'date') {
      //   return !this.studentCompletionForm.START_DATE && this.studentCompletionForm.END_DATE
      // } else {
      //   return false
      // }
      }
    },
    disableCourseDropdown(){
      return (this.courseOptions && this.courseOptions.length > 0) ? false : true
    },
    courseDropdownLabel(){
      return this.disableCourseDropdown ? "No Courses available." : "Select Course"
    }
  },
  methods: {
    formattedDate(dateString) {
      var finalDateString;
      var d = new Date(dateString);
      var mm = d.getMonth() + 1;
      var dd = d.getDate();
      var yy = d.getFullYear();
      if (mm < 10) {
        mm = "0" + mm;
      }
      if (dd < 10) {
        dd = "0" + dd;
      }
      finalDateString = mm + "/" + dd + "/" + yy;
      return finalDateString;
    },

    ...mapActions('reports', [
      'fetchCourses',
      'fetchNYPirpStudentCompletion',
      'generateNYPirpStudentCompletion'
    ]),
    ...mapActions('classes', [
      'one'
    ]),
    ...mapMutations([
      'closeModal'
    ]),
    ...mapMutations('reports', [
      'updateStudentCompletionList',
      'updateStudentCompletionForm',
      'updateSelectedStudents',
      'removeSelectedStudents',
      'clearStudentCompletionList',
      'clearStudentCompletionForm'
    ]),
    generateReport () {
      const vm = this
      return this.$q.dialog({
        title: 'Are you sure?',
        message: 'All students that must be re-reported will now be considered reported. Have you properly reviewed the report?',
        ok: {
          color: 'green',
          icon: "fa fa-gear",
          label: 'Generate'
        },
        cancel: {
          push: true,
          icon: "fa fa-exclamation",
          color: 'grey',
          label: 'Cancel'
        }
      })
      .then(() => this.generateNYPirpStudentCompletion())
      .then(response => {
        if(response) {
          saveAs(
            new Blob([toArrayBuffer(response.content.data)],
            { type: 'application/octet-stream' }),
            'studentCompletionReport.txt'
          )
          this.resetReport()
        }
      })
      .then(() => vm.closeModal('studentCompletion'))
    },
    async select (e, session_id) {
      let vm = this
      let id = e.CLASS_ID
      let mode = e && e.CLASS_ID ? "edit":"add"
      vm.one({
        id: e.CLASS_ID,
        mode: id === "" ? "add" : "edit",
        newClass: (mode === 'add') ? true : false,
        sessionId: session_id
      })
    },
    resetReport () {
      this.clearStudentCompletionList()
      this.clearStudentCompletionForm()
      this.$refs.stepper.reset()
      this.$store.dispatch('courses/fetch', {})
    },
    runReport () {
      return this.fetchNYPirpStudentCompletion()
      .then(response => {
        this.$refs.stepper.next()
      })
    },
    toggleMaximized() {
      this.maximized = !this.maximized
    }
  }
}
</script>

<template>

  <q-modal
    class="sl-modal student-completion-modal"
    :maximized="maximized"
    :no-esc-dismiss="true"
    :no-backdrop-dismiss="true"
    :value="studentCompletionModal"
    :content-css="{width: '1200px', maxWidth: '100%', minHeight: '75vh'}"
    @hide="closeModal('studentCompletion')"
  >
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-toolbar-title>
            <q-icon name="fa fa-certificate" /> Student Completion Report
        </q-toolbar-title>
        <q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />
        <q-icon @click.native="closeModal('studentCompletion')" name="clear" />
      </q-toolbar>
    <q-stepper ref="stepper" v-model="currentStep" no-header-navigation>
      <q-step
        default 
        class=""
        name="start"
        title="Start" 
        done-icon="check"
        subtitle="">
        <div class="relative-position layout-padding" >
          <div class="absolute-center">
            This report shows all the students completed for a given date range.
          </div>
        </div>
      </q-step>
      <!-- <q-step class=""
        name="state"
        order="2" 
        title="Select a state" 
        done-icon="check"
        subtitle="">
        <div class="relative-position layout-padding" >
          <div class="absolute-center">
            Please select a state to search for student completions.
          </div>
        </div>
        <div class="relative-position layout-padding" >
          <div class="absolute-center medium-width">
          <q-select
            clearable
            :options="stateNameOptions"
            :value="studentCompletionForm.LK_STATE_ID"
            placeholder="Choose State"
            @input="value => updateStudentCompletionForm({ 
              field: 'LK_STATE_ID', 
              value: value
            })"
            @blur="fetchCourses()"
          />
          </div>
        </div>
      </q-step> -->
      <q-step class="" 
        name="course"
        order="3"
        title="Pick a course" 
        done-icon="check"
        subtitle="">
        <div class="relative-position layout-padding">
          <div class="absolute-center">
            This report shows all the students completed for a given date range.
          </div>
        </div>
        <div class="relative-position layout-padding">
          <div class="absolute-center large-width">
            <q-select
              clearable
              :options="courseOptions"
              :value="studentCompletionForm.COURSE_ID"
              :placeholder="courseDropdownLabel"
              :disable="disableCourseDropdown"
              @input="value => updateStudentCompletionForm({ 
                field: 'COURSE_ID',
                value: value
              })"
            />
          </div>
        </div>
      </q-step>
      <q-step class="" 
        name="date"
        order="4"
        title="Choose a date range" 
        done-icon="check"
        subtitle="">
        <div class="relative-position layout-padding">
          <div class="absolute-center">
              Please choose a date range to search for student completions.
          </div>
        </div>
        <div class="relative-position layout-padding">
          <div class="sl-row sl-vp ">
            <div class="sl-col-6">
                <q-datetime 
                clearable 
                class="medium-width  float-right" 
                stack-label="Start Date"
                :value="studentCompletionForm.START_DATE" 
                @input="value => updateStudentCompletionForm({ 
                  field: 'START_DATE', 
                  value: value
                })" />
            </div>
            <div class="sl-col-6">
                <q-datetime 
                  clearable  
                  class="medium-width" 
                  stack-label="End Date" 
                  :value="studentCompletionForm.END_DATE"
                  :max="maxEndDate"
                  @input="value => updateStudentCompletionForm({ 
                    field: 'END_DATE', 
                    value: value
                  })"
                />
            </div>
          </div>
        </div>
      </q-step>
      <q-step class="no-padding"
        name="review"
        order="5" 
        title="Review" 
        done-icon="check"
        subtitle="">
        <div v-if="studentCompletionList.length <= 0" class="relative-position layout-padding" >
          <div class="absolute-center">
              No students have completed the course during the period of {{ startDate }} to  {{ endDate }}.
          </div>
        </div>
         <div v-if="studentExceptionList.length <= 0 && studentCompletionList.length > 0" class="relative-position layout-padding" >
          <div class="absolute-center">
              No student exceptions have been found during the period of {{ startDate }} to  {{ endDate }}. Please generate the report.
          </div>
        </div>
        <div v-if="studentExceptionList.length >= 0 && studentCompletionList.length > 0">
          <class-details-modal />
          <q-list>
            <q-item multiline 
              v-for="(item, index) in studentExceptionList"
              :key="index">
              <q-item-side>
                <q-btn
                  @click="select(item)"
                  icon="fa fa-external-link"
                  outline
                  color="primary"
                >
                  <q-tooltip anchor="bottom middle" self="top middle" :offset="[10, 10]">View</q-tooltip>
                </q-btn>
              </q-item-side>
              <q-item-main>
                <q-item-tile label lines="1">{{item.FIRST_NAME + ' ' +item.MIDDLE_NAME + ' ' + item.LAST_NAME}} - {{item.DRIVERS_LICENSE}}</q-item-tile>
                <q-item-tile sublabel lines="2">
                  <span>Class ID - {{item.CLASS_ID}}</span>
                </q-item-tile>
              </q-item-main>
              <q-item-side class="text-red" right>
                {{ item.exceptionInfo }}
                <!-- <q-icon name="fa fa-question-circle" outlined color="negative" size="45px" style="margin-left:5px">
                    <q-tooltip anchor="center right" self="center left" :offset="[10, 10]"><h6 style="font-size:16px; font-weight: bold; text-transform:uppercase; border-bottom:1px solid #888; padding-bottom: 4px;margin-bottom:4px;">Exception Reason:</h6><p style="font-size:20px">{{item.exceptionInfo}}</p></q-tooltip>
                </q-icon> -->
              </q-item-side>
            </q-item>
          </q-list>
          <!-- <Grid 
            :columns="columnOptions"
            :data="studentCompletionExceptionReport"
            :selected="selectedStudents"
            :onSelect="updateSelectedStudents"
            :onLaunch="select"
            :visibleColumns="visibleColumns"
            :hideShowColumns="true"
            info
          >
           <template slot="col-item-exception" slot-scope="props">
              <q-field class="q-pa-md col-4">
                <q-icon name="fa fa-question-circle" outlined color="negative" size="45px" style="margin-left:5px">
                    <q-tooltip anchor="center right" self="center left" :offset="[10, 10]"><h6 style="font-size:16px; font-weight: bold; text-transform:uppercase; border-bottom:1px solid #888; padding-bottom: 4px;margin-bottom:4px;">Exception Reason:</h6><p style="font-size:20px">{{props.value}}</p></q-tooltip>
                </q-icon>
              </q-field>
            </template>
            <template slot="col-item-first_name" slot-scope="props">
              <q-field class="q-pa-md col-4">
                <q-input
                  :float-label="props.col.label"
                  :value="props.value"
                  :disable="true"
                  @keyup.stop="updateStudentCompletionList({ index: props.index, field: props.col.field, value: $event.target.value })">
                </q-input>
              </q-field>
            </template>
            <template slot="col-item-last_name" slot-scope="props">
              <q-field class="q-pa-md col-4">
                <q-input
                  :float-label="props.col.label"
                  :disable="true"
                  :value="props.value">
                </q-input>
              </q-field>
            </template>
            <template slot="col-item-middle_name" slot-scope="props">
              <q-field class="q-pa-md col-4">
                <q-input
                  :float-label="props.col.label"
                  :disable="true"
                  :value="props.value">
                </q-input>
              </q-field>
            </template>
            <template slot="col-item-dob" slot-scope="props">
              <q-field class="q-pa-md col-4">
                <q-input
                  :float-label="props.col.label"
                  :disable="true"
                  :value="props.value">
                </q-input>
              </q-field>
            </template>
            <template slot="col-item-gender" slot-scope="props">
              <q-field class="q-pa-md col-4">
                <q-input
                  :float-label="props.col.label"
                  :disable="true"
                  :value="props.value">
                </q-input>
              </q-field>
            </template>
            <template slot="col-item-completed_date" slot-scope="props">
              <q-field class="q-pa-md col-4">
                <q-input
                  :float-label="props.col.label"
                  :disable="true"
                  :value="props.value">
                </q-input>
              </q-field>
            </template>
            <template slot="col-item-sponsor_code" slot-scope="props">
              <q-field class="q-pa-md col-4">
                <q-input
                  :float-label="props.col.label"
                  :disable="true"
                  :value="props.value">
                </q-input>
              </q-field>
            </template>
            <template slot="col-item-affiliate_code" slot-scope="props">
              <q-field class="q-pa-md col-4">
                <q-input
                  :float-label="props.col.label"
                  :disable="true"
                  :value="props.value">
                </q-input>
              </q-field>
            </template>
            <template slot="col-item-drivers_license" slot-scope="props">
              <q-field class="q-pa-md col-4">
                <q-input
                  :float-label="props.col.label"
                  :disable="true"
                  :value="props.value">
                </q-input>
              </q-field>
            </template>
          </Grid> -->
        </div>
      </q-step>
      <q-inner-loading :visible="loading">
        <q-spinner-puff color="primary" size="70"></q-spinner-puff>
        <span>Running Report..</span>
      </q-inner-loading>
    </q-stepper>
    <q-toolbar slot="footer" class="sl-footer">
      <q-btn color="red" icon="fa fa-trash" label="Remove Selected" @click="removeSelectedStudents()" v-if="currentStep === 'review' && selectedStudents.length > 0 "/>&nbsp;
      <q-btn outline color="red" size="md" @click.native="resetReport()" v-if="currentStep !== 'start'" icon="fa fa-rotate-left" label="Start Over" />&nbsp;
      <q-toolbar-title>
      </q-toolbar-title>
        <q-btn
          color="primary"
          flat
          v-if="currentStep !== 'start'"
          @click="$refs.stepper.previous()"
          label="Back"
        />
        <q-btn
          flat
          class="q-mx-md"
          color="primary"
          v-show="currentStep !== 'date' && currentStep !== 'review'"
          :disable="disableNext"
          @click="$refs.stepper.next();"
          label="Next"
        />
      <q-btn color="green" :loading="loading" @click="runReport()" v-if="currentStep === 'date' || currentStep === 'review'" :disable="disableRun" :icon="runIcon" :label="runLabel" />&nbsp;
      <q-btn color="green" :loading="loading" @click="generateReport()" v-if="currentStep === 'review'" icon="fa fa-gear" label="Generate" />&nbsp;
    </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>

<style lang="stylus" scoped>
// .q-item-side {
//   max-width: 150px
// }

// .student-completion-modal {
//   width: 700px;
// }

.medium-width {
  width: 200px
}
.large-width {
  width: 400px
}
// .q-stepper-step-content
//   height 200px

// .step-content
//   height 200px

.state-select
  width 150px
</style>
